import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/LegalProducts.module.scss'

import { Container } from 'react-bootstrap'

import LegalProductsProduct from './../block/LegalProductsProduct'

class LegalProducts extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      test: 0
    }
  }

  render() {
    const { products, cart, addTocart, authorized } = this.props

    return (
      <section className={styles.section}>
        <div className={styles.sectionGrid}>
          {products.map( ( product, k ) => (
            <LegalProductsProduct key={k} product={product} cart={cart} addTocart={addTocart} authorized={authorized} />
          ))}
        </div>
      </section>
    )
  }
}

LegalProducts.propTypes = {
  products: PropTypes.array,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  authorized: PropTypes.bool
}

LegalProducts.defaultProps = {
  products: [],
  cart: [],
  authorized: false
}

export default LegalProducts